import React, { Component } from 'react'
import { ThemeProvider } from 'emotion-theming'
import Helmet from 'react-helmet'

import defaulttheme from '../../constants/themeConstants'
import Layout from '../../components/core/Layout'
import Header from '../../components/core/Header'
import LandingSection from '../../components/InvestorRelations/LandingSection'
import InvestorsInfoSection from '../../components/InvestorRelations/InvestorInfoSection'
import TabsSection from '../../components/InvestorRelations/TabsSection'

class InvestorRelations extends Component {
  render() {
    return(
      <ThemeProvider theme={defaulttheme}>
      <div>
      <Layout>
      <Helmet title="Investor-Relations | ProYuga" />
      <Helmet>
      <meta
        name="description"
        content="We're offering exciting career opportunities at Proyuga. We welcome top talent in various domains like game development, virtual reality, graphic design and content marketing. Apply now."
      />
      <meta property="og:title" content="How to Become an SEO Expert (8 Steps)" />
      <meta property="og:description" content="Get from SEO newbie to SEO pro in 8 simple steps." />
      </Helmet>
      <Header showHome />
      <LandingSection />
      <TabsSection/>
     </Layout>
     </div>
     </ThemeProvider>
    )
  }
}
export default InvestorRelations
